"use strict";

import development from "./development.js";
import staging from "./staging.js";
import demo from "./demo.js";
import production from "./production.js";
let currentEnv = "staging";
let pluginConfig = development;
let configFromApp = {};

/**
 * Set current environment. Should be called by plugin internally.
 */
export const setSocialEnv = env => {
  currentEnv = env;
  pluginConfig = env === "development" ? development : env === "staging" ? staging : env === "demo" ? demo : production;
};

/**
 * Inject config from consuming app (only required values like API keys).
 */
export const configureSocialEnv = overrides => {
  configFromApp = overrides;
};

/**
 * Unified plugin config — internal + injected merged.
 */
export const getSocialConfig = () => {
  return {
    ...pluginConfig,
    ...configFromApp
  };
};

/**
 * For debugging or conditionally checking environment.
 */
export const getSocialEnv = () => currentEnv;
//# sourceMappingURL=index.js.map